import PropTypes from 'prop-types';

import ScaleLoader from 'Components/ScaleLoader';

import BaseScene from './BaseScene';

const ConsultationLoading = ({ pastDelay, noSurroundingStyle }) => (
  <BaseScene justifyContent="center" noSurroundingStyle={noSurroundingStyle}>
    {pastDelay && <ScaleLoader />}
  </BaseScene>
);

ConsultationLoading.defaultProps = {
  pastDelay: true,
  noSurroundingStyle: false,
};

ConsultationLoading.propTypes = {
  pastDelay: PropTypes.bool,
  noSurroundingStyle: PropTypes.bool,
};

export default ConsultationLoading;
